import { useState, useEffect } from 'react';
import { MenuIcon } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger } from '@shared/ui';
import { useThemeAsset } from '@shared/configs';
import { SideNav } from './SideNav';
import { getNavItemsForRole } from '../constants/nav-items';
import EFL_TEXT from '@shared/assets/pictures/efl_text_font.png';
import HALF_LOGO from '@shared/assets/pictures/eclipse_fitness_lv.png';
import WHITE_EFL_TEXT from '@shared/assets/pictures/efl-text-white.png';
import { UserRole } from '@entities/auth';

// Only Renders within Mobile ViewPort
export const MobileSidebar = ({
  role,
  stripe_link,
}: {
  role: UserRole;
  stripe_link?: string;
}) => {
  const [open, setOpen] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const THEME_LOGO = useThemeAsset(EFL_TEXT, WHITE_EFL_TEXT);
  const NAV_ITEMS = getNavItemsForRole(role, stripe_link);
  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <div className="flex cursor-pointer items-center justify-center gap-2">
            <MenuIcon />
            <img src={HALF_LOGO} height={45} width={50} />
            <img src={THEME_LOGO} height={55} width={175} />
          </div>
        </SheetTrigger>
        <SheetContent side="left" className="w-72 overflow-y-auto bg-efl-blue">
          <div className="px-1 py-6 pt-16 ">
            <SideNav isOpen={open} items={NAV_ITEMS} setOpen={setOpen} />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
